<template>
  <b-notification :closable="false">
    {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-1') }}
    <ul style="list-style-type: square; margin-left: 25px">
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-li-1') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-li-2') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-li-3') }}
      </li>
    </ul>
    {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-2') }}<br />
    {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-3') }}<br />
    {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-4') }}
    <br /><br />
    <b
      ><em>{{
        $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-tit')
      }}</em></b
    ><br />
    {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-1') }}
    <ul style="list-style-type: none; margin-left: 25px">
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-1-li-1') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-1-li-2') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-1-li-3') }}
      </li>
    </ul>
    {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-2') }}
    <ul style="list-style-type: none; margin-left: 25px">
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-2-li-1') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-2-li-2') }}
      </li>
    </ul>
    {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-3') }}
    <ul style="list-style-type: none; margin-left: 25px">
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-3-li-1') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-3-li-2') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-3-li-3') }}
      </li>
    </ul>
    {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-4') }}
    <ul style="list-style-type: none; margin-left: 25px">
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-4-li-1') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-4-li-2') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-4-li-3') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-4-li-4') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-4-li-5') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-4-li-6') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-4-li-7') }}
      </li>
      <li>
        {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-4-li-8') }}
      </li>
    </ul>
    {{ $t('compCarbonFormsCommutesHelpCalculatingMethod.text-ex-5') }}
  </b-notification>
</template>

<script>
export default {
  name: 'HelpCalculatingMethod'
}
</script>
